import React from "react";
import { Component } from "react";
import FixedView from "../../../../components/FixedView";

class TimeWorkingHours extends Component {
    state = {
        setTheTime: false,
    }

    componentDidMount = () => {
        this.setState({ currentTime: this.props.startEnd })
    }

    setTiming = () => {
        const setTheTime = this.state.setTheTime
        this.setState({ setTheTime: !setTheTime })
    }

    setTime = (item) => {
        this.setState({ currentTime: item })
        let key = this.props.weekKey
        let index = this.props.index
        let type = this.props.type
        this.props.updateWeek(key, item, type, index)
    }

    render() {

        return (
            <div>
                <div className="flexc flex-1" >
                    <button className={" br-6 flexcb " + (this.props.locked ? "select-drop-box" : "lock-box")} onClick={() => this.fixedView.showView()}>
                        <div ref={el => this.currentNode = el} className={'w-100 flexcb'}>
                            {this.props.data}
                            <img src="/assets/icons/down-arrow.svg" style={{ opacity: this.props.locked && '50%' }} />
                        </div>
                    </button>
                </div>
                {(this.props.locked && (
                    <FixedView ref={el => this.fixedView = el} nodeRef={this.currentNode} showFocus={false} topOffset={10} width={133} zIndex={1}>

                        <div className="set-time br-6 scroll-no-scrollbar ">
                            <div style={{ width: '100px', paddingBottom: '0.5rem' }}>
                                <input type="search" name="name" style={{ border: 'none', borderBottom: '1px solid #e1e1e1', fontSize: '13px' }} placeholder="Search..." />
                            </div>
                            {this.props.time.map((item, index) => {
                                if (item > this.props.startTime || !this.props.startTime) {
                                    return (
                                        <div onClick={() => (this.setTime(item), this.fixedView.hideView())} className="set-time-item" style={{}}>
                                            {item}
                                        </div>
                                    )
                                }
                            })}

                        </div>
                    </FixedView>))
                }
            </div>
        );
    }
}

export default TimeWorkingHours;